import React from 'react';
import { IconProps } from './model/IconInterface';

const StampIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M12 3a3 3 0 0 0-3 3c0 1.5 1 2.5 1 4H8a3 3 0 0 0-3 3v2h14v-2a3 3 0 0 0-3-3h-2c0-1.5 1-2.5 1-4a3 3 0 0 0-3-3z" /><line x1="5" y1="21" x2="19" y2="21" />
    </svg>
  );
};

export default StampIcon;
